// Route name owned by the billing-detail screen (single-screen → local consts, #878).
export const BILLINGDETAIL_ROUTE_NAME = {
  BILLINGDETAIL: 'billing-detail',
};
